var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.5,
    r: 7,
    stroke: "#D1D1D1",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5303 15.9697L16 15.4393L14.9393 16.5L15.4697 17.0303L16.5303 15.9697ZM18.9697 20.5303C19.2626 20.8232 19.7374 20.8232 20.0303 20.5303C20.3232 20.2374 20.3232 19.7626 20.0303 19.4697L18.9697 20.5303ZM15.4697 17.0303L18.9697 20.5303L20.0303 19.4697L16.5303 15.9697L15.4697 17.0303Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f7414ae9476c081971e1f97d06f90c38.svg";
export { ForwardRef as ReactComponent };